import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent {

  public CurrentDetail:any=[];
  public UserList:any=[];
  public PostList:any=[];
  public largeView:any='';
  public totalCount: number = 0;
  public p = 1;
  public totalCount1: number = 0;
  public p1 = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';

  public loading:boolean = false;
  public imgURL:any='';

  constructor(public router: Router, public service: GlobalService) { 
    this.CurrentDetail= JSON.parse(localStorage.getItem('hva_content') || '{}');
    this.getDetail(this.CurrentDetail._id);   
    // this.imgURL = this.CurrentDetail.image;
  }

  getDetail(id:any){ 
    this.loading=true;
    var url:any='community/detail/'+id;  
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this;  
        this.loading=false;
        this.imgURL = response.data.image;
        this.CurrentDetail= response.data;
        if(response.data.totalMember!=0){
          this.getMDetail(this.p);
        }
        if(response.data.totalPost!=0){
          this.getPDetail(this.p1);
        }
      } else {
        this.CurrentDetail=[];
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  getMDetail(p:any){ 
    this.loading=true;
    var url:any='community/members/'+this.CurrentDetail._id+"?page="+p;  
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) { 
        this.UserList=[]; 
        var self =this;  
        this.loading=false;
        response.data.filter((el:any)=>{
          el.userData.totalPost =el.totalPost;
          self.UserList.push(el.userData)
        })
        this.totalCount= response.totalCounts;
      } else {
        this.UserList=[];
        this.totalCount=0;
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }



  getPDetail(p:any){ 
    this.loading=true;
    var url:any='community/posts/'+this.CurrentDetail._id+"?page="+p;  
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this;  
        this.loading=false;
        response.data.filter((el:any)=>{
          let extension = el.content.split('.').pop();
          if(extension=='mp4' || extension=='wmv' || extension=='avi' || extension=='3gp' ){
            el.type=1;
          } else {
            el.type=2;
          }
        })
        this.PostList= response.data;
        this.totalCount1= response.totalCounts;
      } else {
        this.PostList=[];
        this.totalCount1=0;
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  close(name:any){
    $(name).modal('toggle');
    this.largeView='';
  }
}
